
export function getEstateCountLabel(
    estateCount: number,
    copy: {
        oneProperty: string;
        propertyCountFew: string;
        propertyCountMany: string;
    },
) {
    if (estateCount === 1) {
        return copy.oneProperty;
    }

    if (estateCount > 1 && estateCount < 5) {
        return copy.propertyCountFew.replace("{count}", String(estateCount));
    }

    return copy.propertyCountMany.replace("{count}", String(estateCount));
}
